import {handleDefaultAnchorLinks} from "@global/utilities/anchor-scrolling";

const updateNavigation = (entries) => {
    const enteringEntries = entries.filter((entry) => entry.isIntersecting);
    const leavingEntries = entries.filter((entry) => !entry.isIntersecting);

    leavingEntries.forEach((entry) => {
        const leavingEntry = document.querySelector(".content-navigation__item [href='#" + entry.target.id + "']").parentElement;

        if (leavingEntry) {
            leavingEntry.classList.remove("content-navigation__item--active");
        }
    });

    if (enteringEntries.length) {
        const activeId = enteringEntries[0].target.id;

        const oldActiveItem = document.querySelector(".content-navigation__item--active");

        if (oldActiveItem) {
            oldActiveItem.classList.remove("content-navigation__item--active");
        }

        const activeItem = document.querySelector(".content-navigation__item [href='#" + activeId + "']").parentElement;

        if (activeItem) {
            activeItem.classList.add("content-navigation__item--active");
            activeItem.closest(".content-navigation__list").scroll({left: activeItem.offsetLeft, top: 0, behavior: "smooth"});
        }
    }
}

export const pimContentNavigation = (contentNavigations) => {
    contentNavigations.forEach(contentNavigation => {
        const options = {
            rootMargin: "-20% 0% -80% 0%",
        };

        const observer = new IntersectionObserver(updateNavigation, options);

        const anchorLinks = contentNavigation.querySelectorAll(".content-navigation__item a")

        anchorLinks.forEach((link) => {
            const url = new URL(link.href)

            const target = document.querySelector(url.hash)
            if (target) {
                observer.observe(document.querySelector(url.hash));
                handleDefaultAnchorLinks([link])
            } else {
                link.parentElement.hidden = true;
            }
        })

    })
}
